import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
export function useShowMobileAd(deviation) {
    const deviationType = getDeviationType(deviation);
    const { adsEnabled  } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    const mobileNoVideoAd = useFlag('mobile_web_novideo_ad');
    const adsEnabledDeviation = [
        DeviationTypes.IMAGE
    ].includes(deviationType);
    const adsType = useAdsType();
    return {
        showVideoAd: isMobile && !mobileNoVideoAd && adsEnabled && adsEnabledDeviation && adsType === 'anon',
        showAtfAd: isMobile && mobileNoVideoAd && adsEnabled && adsEnabledDeviation && adsType === 'anon',
        showAdhesionAd: isMobile && adsEnabled
    };
}
